import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import StyleGuideForm from "./StyleGuideForm";

export default function ViewStyleGuide({ name }) {
    return (
        <CustomCard title={name}>
            <StyleGuideForm type="VIEW" />
        </CustomCard>
    );
}
